import _App from "./app";
import _AppWrapper from "./appWrapper";

// ROOT APP CONTAINER
export const App = _App;

// APP LAYOUT WRAPPER CONTAINER
export const AppWrapper = _AppWrapper;
